import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "lib-flexible-computer";
// import "lib-flexible";
import './assets/css/reset.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  let arr = ['purpose','spirit','mission','strength','characteristic', 'group', 'about', 'news']
  if(arr.indexOf(to.name) > -1){
    if(!to.redirectedFrom) return
  }
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
